import { useEffect } from "react"
import { requestWebPushToken, onForegroundPush } from "src/lib/firebase"
import api from "src/apis/api"

// Registers this browser for FCM web push once the user is authenticated, and
// wires foreground pushes to refresh the notification bell. Best-effort and
// self-contained: any failure (permission denied, unsupported browser, missing
// VAPID key) is swallowed so it never disrupts the app.
export function useWebPush(isAuthenticated) {
  useEffect(() => {
    if (!isAuthenticated) return

    let unsubscribe = () => {}
    let cancelled = false

    ;(async () => {
      try {
        const token = await requestWebPushToken()
        if (cancelled || !token) return

        await api.post("/api/v1/device_token", {
          token,
          device_name: navigator.userAgent,
        })

        unsubscribe = await onForegroundPush(() => {
          // Nudge the bell (polls every 30s otherwise) and let listeners react.
          window.dispatchEvent(new CustomEvent("clozdl:notifications-refresh"))
        })
      } catch {
        // best-effort — web push is a nice-to-have, never block the session.
      }
    })()

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [isAuthenticated])
}
